
import type { PropType } from 'vue'

import type { ClusterFeatureEntity } from '@/modules/DispatcherWorkplaceModule/types'
import type { ClusterFeature } from '@/modules/YandexMap3Module/map-cluster.types'

import { defineComponent } from 'vue'

import DwRecordPopupFeature from '@/modules/DispatcherWorkplaceModule/components/DwRecordPopupFeature/index.vue'
import DwClusterPopupSelectedFeatureFooter from './SelectedFeatureFooter.vue'

export default defineComponent({
    components: {
        'dw-record-popup-feature': DwRecordPopupFeature,
        'dw-cluster-popup-selected-feature-footer': DwClusterPopupSelectedFeatureFooter,
    },
    props: {
        feature: {
            type: Object as PropType<ClusterFeature<ClusterFeatureEntity>>,
            required: true
        },
        featureIndex: {
            type: Number,
            default: 0
        },
        featuresLength: {
            type: Number,
            default: 0
        }
    },
    emits: [
        'close',
        'open-group',
        'select-previous',
        'select-next',
        'change-date',
        'add-to-wait-list',
        'assign',
        'self-delivery'
    ],
    setup(props, { emit }) {
        const onClose = () => {
            emit('close')
        }

        const onOpenGroup = () => {
            emit('open-group')
        }

        const onSelectPrevious = () => {
            emit('select-previous')
        }

        const onSelectNext = () => {
            emit('select-next')
        }

        const onChangeDate = (feature: ClusterFeature<ClusterFeatureEntity>) => {
            emit('change-date', feature)
        }

        const onAddToWaitList = (feature: ClusterFeature<ClusterFeatureEntity>) => {
            emit('add-to-wait-list', feature)
        }

        const onAssign = (feature: ClusterFeature<ClusterFeatureEntity>) => {
            emit('assign', feature)
        }

        const onSelfDelivery = (feature: ClusterFeature<ClusterFeatureEntity>) => {
            emit('self-delivery', feature)
        }

        return {
            onClose,
            onOpenGroup,
            onSelectPrevious,
            onSelectNext,
            onChangeDate,
            onAddToWaitList,
            onAssign,
            onSelfDelivery,
        }
    }
})
